<div class="bk-dialog bk-dialog__event">

    <button class="bk-modal__close_btn"
        (click)="onClose()"
		type="button">
		<mat-icon>close</mat-icon>
	</button>

    <h4 mat-dialog-title>
        {{'Edit' | translate }} {{'Ranch Information' | translate }}
    </h4>

    <!-- body -->

    <div mat-dialog-content>
        <ranch-basic-form
            [inEditMode]="true"
            (formReady)="setForm($event)">
        </ranch-basic-form>
    </div>

    <!-- footer -->

    <div mat-dialog-actions align="end">
        <button *ngIf="permissions && permissions.UserIsRanchOwner"
            class="bk-button__delete"  
            (click)="onDeleteConfirmationOpen()">
            {{'Delete' | translate }}
        </button>

        <button mat-button
            class="bk-button bk-button--medium bk-button--text-only
            bk-dialog__button--secondary"
            (click)="onClose()">
            {{'Cancel' | translate }}
        </button>

        <button mat-button
            [disabled]="!form || !form.valid"
            class="bk-button bk-button--medium"
            (click)="edit()">
            {{ (isSaving ? 'Saving' : 'Save') | translate }}
            <img class='bk-button__loader' *ngIf='isSaving' src='/assets/images/loader-20px.gif'/>
        </button>
    </div>
</div>
